import unverificated from '@/shared/assets/icons/profile/unverificated.svg'
import verificated from '@/shared/assets/icons/profile/verificated.svg'

type Props = {
  status: 'done' | 'failed'
  className?: string
}

export const VerificationStatus = ({ status, className }: Props) => {
  return (
    <div className={`flex gap-1 items-center font-medium text-base ${className ? className : ''}`}>
      <span
        className={`${status === 'done' ? 'text-text-verificated' : 'text-text-unverificated'}`}
      >
        {status === 'done' ? 'Верификация пройдена' : 'Верификация не пройдена'}
      </span>
      <img
        src={status === 'done' ? verificated : unverificated}
        className="w-5 h-5 md:w-6 md:h-6"
      />
    </div>
  )
}
